import React from "react"
import UploadFileView from "./UploadFileView";

const UploadFileViewController = () => {
    return (
        <UploadFileView />
    );
}

export default UploadFileViewController;